<template>
  <div>
    <div :style="'display: flex; flex-direction: column; justify-content: center; align-items: center;'">
        <img :src="getImagePath" :style="'width: 150px; height: 150px; transform: rotate('+getRotateDegree+'deg)'"/>
        <div :style="'display: flex; flex-direction: row; justify-content: center; align-items: center; margin: 10px;'">

        <el-button type="primary" @click="openFileDialog" size="small" icon="el-icon-camera-solid">{{processing ? 'capturando...' : 'Captura'}}</el-button>            
        <el-button @click="rotateImage" type="info" size="small" icon="el-icon-refresh-right">Girar</el-button>

        </div>
        <input type="file" :id="file_dialog_id" @change="uploadImageToCDN" :accept="'image/*;capture=camera'" style="display: none;">        
        
    </div>  
  
  </div>
</template>

<script>
import axios from 'axios'

export default {
    props: ['image_path', 'file_dialog_id'],
    data() {
        return {
            uploaded_image_path: 'https://etacdn.b-cdn.net/website/blank_image.png',
            camera_visible: false,
            processing: false,
            rotate: 0
        }
    },
    computed: {
        getRotateDegree() {
            return this.$store.state.events.guests.props.picture_angle
        },
        getImagePath() {
            if(this.image_path != null && this.image_path.length>0) {
                return this.image_path    
            }
            return this.uploaded_image_path
        }
    },
    methods: {
        rotateImage() {
            this.$store.state.events.guests.props.picture_angle = (this.getRotateDegree*2)
            if(this.getRotateDegree === 720 || this.getRotateDegree === 0) {
                this.$store.state.events.guests.props.picture_angle = 90
            }
        },
        getImage(data) {
            this.uploaded_image_path = data
            this.sendImageBack()
        },
        openFileDialog() {
            document.getElementById(this.file_dialog_id).click()            
        },
        uploadImageToCDN() {
            
            this.processing = true
            let data = new FormData();
            
            data.append('file', document.getElementById(this.file_dialog_id).files[0]);
            
            axios.post('/serviceProviderPortal/guest/uploadFile.php', data)
            .then(res => {
                
                console.log(JSON.stringify(res.data))
                if(res.data.status) {
                    this.uploaded_image_path = res.data.image_path
                    this.sendImageBack()
                }

            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                this.processing = false
            })

        },
        sendImageBack() {
            
            this.$emit('uploaded', this.uploaded_image_path)
            
        }
    },
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/UploadFile.vue